// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__gurzB","content":"Consent_content__3Jnwk","footer":"Consent_footer__6BPVV"};